import { memo } from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LinkIcon from '@mui/icons-material/Link';
import { providersLabelMap } from 'root/src/shared/constants/providers';
import { PlatformIcon } from 'root/src/client/web/base/CustomButton/PlatformIcon';
import { useSettingsDialog } from 'root/src/client/v2/profile/features/ProfileSettingsDialog/settingsDialog.context';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { RedesignModalShell } from 'root/src/client/v2/common/components/RedesignModalShell';
import { Button } from 'root/src/client/v2/common/components/ui/button';
import { joinWithOr } from 'root/src/client/v2/common/helpers/joinWithOr';
export const platformLabel = (platform) => { var _a; return (_a = providersLabelMap[platform]) !== null && _a !== void 0 ? _a : platform; };
// "TikTok", "TikTok or YouTube", "Twitch, TikTok or YouTube".
export const formatPlatformLabels = (platforms) => joinWithOr(platforms.map(platformLabel));
// Shown when a creator has no connected account on any platform this dare accepts. The dare cannot be
// accepted at all in that state (the accept flow has no assignee to submit), so this explains the
// requirement and points at the channels settings rather than letting the accept fail server-side.
export const RedesignPlatformRequirementModal = memo(({ platforms }) => {
    const modal = useRedesignModal();
    const { openSettings } = useSettingsDialog();
    const isSingle = platforms.length === 1;
    const onConnect = () => {
        modal.hide();
        openSettings('channels');
    };
    return (<RedesignModalShell className="sm:max-w-md">
			<div className="flex w-full flex-col items-center gap-3 text-center">
				<div className="flex h-12 w-12 items-center justify-center rounded-full border border-solid border-white/[0.08] bg-white/[0.04]">
					<LockOutlinedIcon sx={{ fontSize: 24 }} className="text-muted-foreground"/>
				</div>
				<h2 className="font-display text-xl font-bold text-foreground">
					{formatPlatformLabels(platforms)} account required
				</h2>
				<p className="text-sm text-muted-foreground">
					This dare can only be delivered on {formatPlatformLabels(platforms)}, so you need{' '}
					{isSingle ? 'that account' : 'one of those accounts'} connected before you can accept it.
				</p>
			</div>

			<ul className="flex w-full flex-col gap-2">
				{platforms.map(platform => (<li key={platform} className="flex items-center gap-2.5 rounded-xl border border-solid border-white/[0.08] bg-white/[0.03] px-3 py-2.5">
						<PlatformIcon platform={platform} size="1x"/>
						<span className="flex-1 truncate text-sm font-medium text-foreground">{platformLabel(platform)}</span>
						<span className="shrink-0 rounded-full border border-solid border-white/[0.08] bg-white/[0.04] px-2 py-0.5 text-[10px] font-semibold text-muted-foreground">
							Not connected
						</span>
					</li>))}
			</ul>

			<div className="flex w-full gap-2">
				<Button variant="secondary" onClick={modal.hide} className="flex-1 rounded-lg text-sm">Close</Button>
				<Button variant="brand" onClick={onConnect} className="flex-1 gap-1.5 rounded-lg text-sm font-semibold">
					<LinkIcon sx={{ fontSize: 16 }}/>
					Connect
				</Button>
			</div>
		</RedesignModalShell>);
});
